<script setup lang="ts">
import { containsImage, hasNodes } from "~/utils/helper/magnolia";
import { contentToTailwindClasses } from "~/utils/helper/tailwind";
import DotPattern from "~/templates/elements/DotPattern.vue";
import PictureElement from "~/templates/elements/PictureElement.vue";
import NewsletterBenefits from "~/templates/elements/NewsletterBenefits.vue";
import { Heading } from "~/components/clarity-ui/Heading";
import { Paragraph } from "~/components/clarity-ui/Paragraph";
const { isDesktop, isTabletOrMobile } = useDevice();

const props = defineProps([
  "headline",
  "subline",
  "steps",
  "backgroundColor",
  "dotPattern",
  "image",
  "imageFirst",
  "steps",
]);

const hasImage = containsImage(props.image);
</script>

<template>
  <Transition
    appear
    mode="out-in"
    enter-active-class="transition-[grid-template-rows] duration-300 ease-out"
    enter-from-class="grid-rows-[0fr]"
    enter-to-class="grid-rows-[1fr]"
    leave-active-class="transition-[grid-template-rows] duration-400 ease-in"
    leave-from-class="grid-rows-[1fr]"
    leave-to-class="grid-rows-[0fr]"
  >
    <div class="grid overflow-hidden">
      <div class="overflow-hidden">
        <div
          :class="[contentToTailwindClasses({ backgroundColor })]"
          class="relative mt-6 overflow-hidden rounded-xl md:mt-10"
        >
          <slot name="editorialNotification"></slot>
          <DotPattern v-if="dotPattern" :variant="dotPattern" />
          <div
            :class="{
              'md:px-16 xl:w-full xl:px-12': hasImage,
            }"
            class="relative grid gap-6 px-4 py-8 md:mx-auto md:w-10/12 md:gap-y-8 md:px-0 md:py-12 xl:grid-cols-5"
          >
            <PictureElement
              v-if="hasImage"
              :class="{ 'order-last': !imageFirst && isTabletOrMobile }"
              :img="image"
              class="z-10 xl:order-first xl:col-span-2 xl:col-start-4 xl:row-start-1"
              img-class="object-cover aspect-4/3 rounded-xl overflow-hidden mx-auto"
            />

            <div
              ref="contentGroup"
              :class="[hasImage && isDesktop ? 'col-span-3' : 'col-span-full']"
              class="content-group flex flex-col gap-6"
            >
              <Heading v-if="headline?.text" class="mb-4" color="blue" :tag="headline?.tag ?? 'h2'">
                {{ headline?.text }}
              </Heading>
              <Paragraph v-if="subline" class="mb-6">
                {{ subline }}
              </Paragraph>
              <NewsletterBenefits v-if="hasNodes(steps)" :benefits="steps" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>
